/**
 * assets/feature-viewer-3d.js
 * - Original markup support
 * - Impact-safe: initializes on initial load + Shopify section reload
 * - Default FOV fallback (data-default-fov on section)
 * - Debug toggle (data-debug="true")
 */

(function () {
  function initAll() {
    document.querySelectorAll(".feature-viewer-section").forEach((root) => {
      if (root.dataset.fv3dInited === "true") return;
      root.dataset.fv3dInited = "true";
      initOne(root);
    });
  }

  function initOne(root) {
    const viewer = root.querySelector("model-viewer");
    const features = Array.from(root.querySelectorAll(".feature"));
    const hotspots = Array.from(root.querySelectorAll(".hotspot"));
    const slider = root.querySelector(".feature-slider");
    const dots = Array.from(root.querySelectorAll(".slider-dot"));
    if (!viewer || !features.length) return;

    const defaultFov = (root.getAttribute("data-default-fov") || "30deg").trim();
// ===== Fullscreen (native + fallback) =====
const fsFrame = root.querySelector("[data-fv3d-fs-frame]");
const fsBtn = root.querySelector("[data-fv3d-fs]");

if (fsFrame && fsBtn) {
  const setUi = (active) => {
    fsBtn.classList.toggle("is-active", active);
    fsBtn.setAttribute("aria-label", active ? "Vollbild schließen" : "Vollbild öffnen");
  };

  const enterPseudo = () => {
    fsFrame.classList.add("is-pseudo-fs");
    document.documentElement.classList.add("fv3d-lock");
    setUi(true);
  };

  const exitPseudo = () => {
    fsFrame.classList.remove("is-pseudo-fs");
    document.documentElement.classList.remove("fv3d-lock");
    setUi(false);
  };

  fsBtn.addEventListener("click", async () => {
    const isPseudo = fsFrame.classList.contains("is-pseudo-fs");
    const isNative = document.fullscreenElement === fsFrame;

    if (isPseudo) return exitPseudo();

    if (isNative || document.fullscreenElement) {
      try { await document.exitFullscreen(); } catch (_) {}
      return;
    }

    if (fsFrame.requestFullscreen) {
      try { await fsFrame.requestFullscreen(); }
      catch (_) { enterPseudo(); }
    } else {
      enterPseudo();
    }
  });

  document.addEventListener("fullscreenchange", () => {
    setUi(document.fullscreenElement === fsFrame);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && fsFrame.classList.contains("is-pseudo-fs")) exitPseudo();
  });
}
    // Order from dots (we set data-id in the section)
    const featureOrder =
      dots.length && dots.every((d) => d.dataset.id)
        ? dots.map((d) => d.dataset.id)
        : [...new Set(features.map((f) => f.dataset.id).filter(Boolean))];

    function setActiveStates(id) {
      features.forEach((f) => f.classList.toggle("active", f.dataset.id === id));
      hotspots.forEach((h) => h.classList.toggle("active", h.dataset.id === id));

      const idx = featureOrder.indexOf(id);
      if (idx >= 0 && dots.length) {
        dots.forEach((d, i) => d.classList.toggle("active", i === idx));
      }
    }

   function setCameraFromId(id) {
  const source =
    features.find((f) => f.dataset.id === id && (f.dataset.orbit || f.dataset.fov)) ||
    features.find((f) => f.dataset.id === id) ||
    null;
  if (!source) return;

  const orbit = (source.dataset.orbit || "").trim();
  const fov = (source.dataset.fov || "").trim();

  if (typeof viewer.resetTurntableRotation === "function") {
    viewer.resetTurntableRotation();
  }

  // Orbit: am stabilsten als Attribut setzen (unterstützt auch % wie "105%")
  if (orbit) {
    viewer.setAttribute("camera-orbit", orbit);
    // optional zusätzlich die Property (schadet nicht):
    viewer.cameraOrbit = orbit;
  }

  // FOV: WICHTIG für "auto" -> als Attribut setzen
  const finalFov = fov || defaultFov;
  viewer.setAttribute("field-of-view", finalFov);
  // optional zusätzlich die Property:
  viewer.fieldOfView = finalFov;
}
    function activate(id, scrollSlider = true) {
      if (!id) return;
      setCameraFromId(id);
      setActiveStates(id);

      if (slider && scrollSlider) {
        const card = slider.querySelector(`.feature[data-id="${CSS.escape(id)}"]`);
        if (card) card.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    }

    // Feature clicks
    features.forEach((feature) => {
      feature.addEventListener("click", () => activate(feature.dataset.id, true));
    });

    // Hotspot clicks
    hotspots.forEach((hotspot) => {
      hotspot.addEventListener("click", (e) => {
        e.stopPropagation();
        activate(hotspot.dataset.id, true);
      });
    });

    // Dot clicks
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        const id = dot.dataset.id || featureOrder[i];
        activate(id, true);
      });
    });

    // Mobile scroll -> nearest card
    if (slider) {
      let ticking = false;
      slider.addEventListener("scroll", () => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          const cards = Array.from(slider.querySelectorAll(".feature"));
          let closest = null;
          let minOffset = Infinity;

          cards.forEach((card) => {
            const rect = card.getBoundingClientRect();
            const offset = Math.abs(rect.left + rect.width / 2 - window.innerWidth / 2);
            if (offset < minOffset) {
              minOffset = offset;
              closest = card;
            }
          });

          if (closest) activate(closest.dataset.id, false);
          ticking = false;
        });
      });
    }

    // Initial
    const initial = root.querySelector(".feature.active") || features[0];
    if (initial) activate(initial.dataset.id, false);

    // ===================== DEBUG MODE =====================
    const debugOn = root.getAttribute("data-debug") === "true";
    if (!debugOn) return;

    // HUD (won't block clicks)
    const wrapper = viewer.parentElement;
    if (wrapper) wrapper.style.position = wrapper.style.position || "relative";

    const hud = document.createElement("div");
    hud.style.cssText =
      "position:absolute;left:12px;bottom:12px;z-index:999;padding:10px 12px;border-radius:12px;" +
      "background:rgba(255,255,255,.92);border:1px solid rgba(0,0,0,.15);font:12px/1.35 system-ui;max-width:360px;" +
      "pointer-events:none;";
    hud.innerHTML =
      "<b>Debug: Hotspot Finder</b><br>" +
      "Shift + Click: log position<br>" +
      "C: log camera orbit/FOV";
    wrapper && wrapper.appendChild(hud);

    // Debug marker
    let marker;
    function ensureMarker() {
      if (marker) return marker;
      marker = document.createElement("button");
      marker.textContent = "+";
      marker.slot = "hotspot-debug";
      marker.style.cssText =
        "width:34px;height:34px;border-radius:999px;border:1px solid rgba(0,0,0,.22);" +
        "background:rgba(255,255,255,.95);box-shadow:0 8px 20px rgba(0,0,0,.10);font-weight:700;" +
        "display:grid;place-items:center;cursor:default;";
      viewer.appendChild(marker);
      return marker;
    }

    // Shift + Click to log hit (capture helps if model-viewer eats events)
    viewer.addEventListener(
      "click",
      (e) => {
        if (!e.shiftKey) return;
        console.log("[FV3D Debug] Shift+Click received ✅");

        if (typeof viewer.positionAndNormalFromPoint !== "function") {
          console.warn("[FV3D Debug] positionAndNormalFromPoint() not available in this model-viewer build.");
          return;
        }

        let hit = null;
        try {
          hit = viewer.positionAndNormalFromPoint(e.clientX, e.clientY);
        } catch (_) {}

        if (!hit || !hit.position) {
          const rect = viewer.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          try {
            hit = viewer.positionAndNormalFromPoint(x, y);
          } catch (_) {}
        }

        if (!hit || !hit.position) {
          console.warn("[FV3D Debug] No hit (click on the mesh, not empty background).");
          return;
        }

        const p = hit.position;
        const posStr = `${p.x.toFixed(3)}m ${p.y.toFixed(3)}m ${p.z.toFixed(3)}m`;
        ensureMarker().dataset.position = posStr;

        console.log("[FV3D Debug] Hotspot position:", posStr);

        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(posStr).catch(() => {});
        }
      },
      true
    );

    window.addEventListener("keydown", (e) => {
      if (e.key.toLowerCase() !== "c") return;
      const orbit = viewer.cameraOrbit;
      const fov = viewer.fieldOfView;
      const orbitStr = orbit?.toString ? orbit.toString() : String(orbit || "");
      const fovStr = fov?.toString ? fov.toString() : String(fov || "");
      console.log("[FV3D Debug] Camera Orbit:", orbitStr);
      console.log("[FV3D Debug] Camera FOV:", fovStr);
    });
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify theme editor / Impact: re-initialize after section reload
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
})();